import dayjs from 'dayjs';
import { defineComponent, computed, ref } from '@vue/composition-api';
import { permissionApi } from '@/services';
import { useExpire } from './index';
import { Org } from '../RoleList';
import { message } from 'ant-design-vue';
export const BatchUpdateExpire = defineComponent({
    name: 'BatchUpdateExpire',
    props: {
        projectId: {
            type: String,
            required: true,
        },
        envId: {
            type: String,
            required: true,
        },
        rawRoleUserList: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {
        const columns = [
            {
                title: '用户/组织名',
                dataIndex: 'userName',
                key: 'userName',
                customRender: (userName, record) => (record.userType === 'org'
                    ? <Org record={record}/>
                    : userName),
            },
            {
                title: '角色名',
                dataIndex: 'role',
                key: 'role',
            },
            {
                title: '状态',
                dataIndex: 'disabled',
                key: 'disabled',
                customRender: (disabled) => (disabled ? <a-tag color="red">已过期禁用</a-tag> : <a-tag color="green">生效中</a-tag>),
            },
            {
                title: '过期时间',
                dataIndex: 'expireAt',
                key: 'expireAt',
                customRender: (expireAt) => (expireAt ? dayjs(expireAt).format('YYYY-MM-DD HH:mm:ss') : '永不过期'),
            },
        ];
        const { expireOptions, renderCreateExpire } = useExpire(ref([]));
        const selectedRowKeys = ref([]);
        const selectedExpireDays = ref(NaN);
        const getExpireAtFromNow = (days) => dayjs().add(days, 'day')
            .valueOf();
        const filterRoleUserList = computed(() => {
            if (isNaN(selectedExpireDays.value))
                return props.rawRoleUserList;
            if (selectedExpireDays.value === -1)
                return props.rawRoleUserList.filter(item => item.disabled);
            const validRoleUserList = props.rawRoleUserList.filter(item => !item.disabled);
            if (selectedExpireDays.value === 0)
                return validRoleUserList.filter(item => !item.expireAt);
            return validRoleUserList.filter(item => item.expireAt
                && item.expireAt < getExpireAtFromNow(selectedExpireDays.value));
        });
        return {
            columns,
            selectedRowKeys,
            selectedExpireDays,
            filterRoleUserList,
            renderCreateExpire,
            expireOptions,
        };
    },
    render() {
        const setExpires = async () => {
            const roles = this.rawRoleUserList.filter(item => this.selectedRowKeys.includes(item._id));
            try {
                await Promise.all(roles.map(role => permissionApi.createRoleUser(this.projectId, this.envId, {
                    bizId: role.bizId,
                    users: role.userType === 'staff' ? [role.userId] : [{ label: role.userName, value: role.userId }],
                    roles: [role.role],
                    type: role.userType,
                    expireRoles: [this.expireOptions.expireAt],
                })));
                message.success('设置过期时间成功');
                this.selectedRowKeys = [];
                this.$emit('success');
            }
            catch (e) {
                message.error('设置过期时间失败');
            }
        };
        return <div>
      <section style="margin-bottom:16px">
        <div style="display:flex;justify-content:space-between">
          <div>
            <a-popconfirm icon={<span />} placement="right" trigger={this.selectedRowKeys.length ? 'click' : ''} onConfirm={setExpires}>
              <div slot="title">
                <a-form-model>
                  {this.renderCreateExpire()}
                </a-form-model>
              </div>
              <a-button type="primary" disabled={!this.selectedRowKeys.length}>设置过期时间</a-button>
            </a-popconfirm>
          </div>
          <div>
            <a-radio-group v-model={this.selectedExpireDays} button-style="solid">
              <a-radio-button value={-1}>已过期禁用</a-radio-button>
              <a-radio-button value={7}>7 天内过期</a-radio-button>
              <a-radio-button value={30}>30 天内过期</a-radio-button>
              <a-radio-button value={0}>永不过期</a-radio-button>
            </a-radio-group>
          </div>
        </div>
      </section>
      <a-table columns={this.columns} rowKey="_id" dataSource={this.filterRoleUserList} rowSelection={{
                selectedRowKeys: this.selectedRowKeys,
                onChange: (selectedRowKeys) => {
                    this.selectedRowKeys = selectedRowKeys;
                },
            }}>
      </a-table>
    </div>;
    },
});
